module.exports = __webpack_public_path__ + "img/RightButtonNormal.9ce61346.webp";